<template>
  <layout 
    :showuserinfo="false" 
    title="Penguatkuasaan" 
    :crumbs="crumbs"
  >
    <z-page title="Notis Pentadbiran">
      <w-dialog
        v-model="dialog.show"
        :fullscreen="dialog.fullscreen"
        :width="dialog.width"
        :persistent="dialog.persistent"
        :persistent-no-animation="dialog.persistentNoAnimation"
        title-class="primary-light1--bg white">
        <template #title>
          <w-icon class="mr2">fal fa-cog</w-icon>
          Sunting
        </template>

        <w-form 
          ref="dform" 
          v-model="dialog.valid"
          @validate="submit"
          @success="success"
        >
        
        <z-input label="Name" name="name" :validators="[validators.required]" />

        <z-input class="mt3" label="No. Kad Pengenalan" name="kadpengenalan" :validators="[validators.required]" />

        <z-input class="mt3" label="Hakmilik" name="hakmilik" :validators="[validators.required]" />

        <z-input class="mt3" label="Jenis PB" name="jenispb" :validators="[validators.required]" />

        <z-input class="mt3" label="Syer" name="syer" :validators="[validators.required]" />

        <z-input class="mt3" label="Nama Atas Bil" name="namaatasbil" :validators="[validators.required]" />

        </w-form>

        
        <template #actions>
          <div class="spacer" />
          <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
          <w-button 
          class="ml1" 
          :loading="dialog.loading"
          @click="$refs.dform.validate()"
          >
            Simpan
          </w-button>
        </template>  
      </w-dialog>

      <z-table 
        ref="tblcukai" 
        title="Senarai Notis Pentadbiran" 
        :headers="table.headers" 
        :items="table.items" 
        :meta="table.meta"
      >

        <template #button>
          <inertia-link :href="$route('penguatkuasaan.pentadbiran.show',5)" class="w-button w-button--dark size--md indigo-dark2--bg ml1 fs-2 indigo-dark2--bg ml1 fs-2">
            <w-icon class="mr1" xs>fal fa-plus</w-icon> Cipta
          </inertia-link>
        </template>

        <template #item-cell.action="{ item, label, header, index }">
          <w-flex class="flex justify-center">
            <inertia-link :href="$route('penguatkuasaan.pentadbiran.show',item.id)">
            <w-tooltip top>
                <template #activator="{ on }">
                  <w-icon v-on="on" >
                    fal fa-file
                  </w-icon>
                </template>
                Papar
              </w-tooltip>
            </inertia-link>
          </w-flex>
        </template>
      </z-table>
    </z-page>
  </layout>
</template>

<script>
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'cukai-tanah',
      reload: true,
      crumbs: [
        { label: this.$page.props.app_name, route: '/' },
        { label: 'Cukai Tanah', route: '/cukai-tanah/dashboard' },
        { label: 'Penguatkuasaan', route: '/cukai-petak/senarai' },
        { label: 'Notis', route: '/cukai-petak/senarai' },
        { label: 'Pentadbiran', route: '/cukai-petak/senarai' },
      ],
      form: {
      },
    }
  },
  methods: {
       
  },
  watch: {
    
  },
  mounted() {

  },
}
</script>